import { useState } from "react"

import { ParadiseSearchMultiSelect } from "src/components/Paradise/ParadiseSearchMultiSelect"
import { useFetchParadiseUsers } from "src/data/paradise/paradiseUsers/queries/paradiseUserQueries"

export function ParadiseSelectUsersByEmail({
  selectedUserIds,
  onChange,
}: {
  selectedUserIds: string[]
  onChange: (userIds: string[]) => void
}) {
  const [searchedValue, setSearchedValue] = useState("")

  const fetchedUsers = useFetchParadiseUsers({
    filter: {
      email: searchedValue,
    },
    options: {
      keepPreviousData: true,
    },
  })

  return (
    <ParadiseSearchMultiSelect
      placeholder="Search by email"
      selectedValues={selectedUserIds}
      options={
        fetchedUsers.data?.users.map((u) => ({
          label: u.email,
          value: u.id,
        })) ?? []
      }
      onChange={onChange}
      onSearch={setSearchedValue}
      isLoading={fetchedUsers.isLoading}
      isLoadingMore={fetchedUsers.isPreviousData}
      error={
        fetchedUsers.error?.message ? fetchedUsers.error.message : undefined
      }
    />
  )
}
